import React from 'react';
import { NoMatchText, MacroButton } from '../../../../DecisionTree.styles';
import { useDispatch } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import { Title, NoResultsWrapper } from './NoSearchResults.styles';

const NoSearchResults = () => {
  const dispatch = useDispatch();

  return (
    <NoResultsWrapper key={'noAccountFound'}>
      <Title>No account found</Title>
      <NoMatchText marginTop={'10px'}>Next steps you can take:</NoMatchText>
      <NoMatchText marginTop={'10px'}>1. You can try asking the customer another data for search.</NoMatchText>
      <NoMatchText marginTop={'7px'}>
        2. Once you have received a response from the customer, use the updated <br />
        customer information to search again.
      </NoMatchText>
      <MacroButton active={true} onClick={() => dispatch(addEdgeToDecisionTreePath('no_account_found'))}>
        GET MACRO
      </MacroButton>
    </NoResultsWrapper>
  );
};

export default NoSearchResults;
